// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3avaf","footer":"ModalCreateQualiphyProcedure_footer__1kjb_","additionData":"ModalCreateQualiphyProcedure_additionData__2S9eI"};